import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    url: String,
    recordName: String,
    attributeName: String
  }

  connect() {
    if (this.urlValue !== undefined && this.urlValue !== "") {
      this.inputTarget.addEventListener("change", event => {
        const record = {}
        record[this.attributeNameValue] = this.inputTarget.value
        const body = {}
        body[this.recordNameValue] = record
        
        patch(this.urlValue, {
          headers: {
            Accept: "text/vnd.turbo-stream.html"
          },
          body: body
        })
      })
    }
  }

  add() {
    this.inputTarget.value = Number(this.inputTarget.value) + 1
    this.inputTarget.dispatchEvent(new Event('change'));
  }

  sub() {
    const newInput = Math.max(1, this.inputTarget.value - 1)
    if (newInput >= Number(this.inputTarget.min)) {
      this.inputTarget.value = newInput;
      this.inputTarget.dispatchEvent(new Event('change'));
    }
  }
}